export default __webpack_public_path__ + "static/media/JBTCB-BNB.cef0c2d0.svg";